<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="showDialog"
        :cons="cons"
        hide-confirm
        hide-overlay
        max-width="900"
        transition="dialog-bottom-transition"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-data-show-download-d`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('download_qr')"
          />
        </template>
        <v-card class="pa-5">
        <download-file-with-api
          v-if="showDialog"
          :address="`${data?.domain?.name||'qrland.in/'}${data.identifier}`"
          :qr_id="data?.qrId"
          :visit-name="data.visitName || ''"
          :preloaded-info="data"          
          :svg="qrSvgDataUrl"             
          @close="showDialog = false"
          :isQrlink="['qrlink','clickyarseo'].includes(data?.type?.toLowerCase())"
        />   
        </v-card>
      </custom-popup>
      <div class="p-5">
        <v-card :loading="loading" class="p-5" flat>
          <v-row class="pb-0 pt-4">
            <v-col cols="12" md="4" style="height: fit-content">
              <v-col class="pa-2" cols="12">
                <img
                  :src="qrSvgDataUrl"
                  alt=""
                  class="cursor-pointer"
                  width="100%"
                  @click.stop="downloadSvgImg(qrSvgDataUrl, 0)"
                />
              </v-col>
              <v-row class="pb-0 pt-4 coverdownload">
                <v-col class="downloadbtn pa-0 ma-0" cols="12" md="12">
                  <qr-maker
                    :loading="loading"
                    class="sticky-md"
                    style="top: 110px"
                  />
                  <v-btn
                    class="btn-download ma-0 pa-0"
                    style="width: 80%"
                    @click="showDialog = true"
                    :disabled="!(!hasChanges || loading)"

                  >
                    <v-icon>mdi-progress-download</v-icon>
                    {{ $t("download_qr") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="!!qrDesign" cols="12" md="8">
              <div style="display: flex; flex-direction: row">
                  <!-- دکمه جدید سیاه و سفید -->
                  <v-btn
                    class="btn-buy rounded-lg mt-n1 mr-2"
                    depressed
                    outlined
                    :disabled="loading"
                    @click="setBlackAndWhite"
                  >
                    <v-icon right class="ml-2">mdi-qrcode</v-icon>
                    سیاه و سفید
                  </v-btn>

                <v-btn
                  :loading="loading"
                  class="mt-n1 submit-btn"
                  depressed
                  :disabled="!hasChanges || loading"
                  @click="updateStyle(false)"
                  style="justify-content: end"
                >
                  {{ $t("apply_changes") }}
                  <span class="fa fa-save ml-1" style="font-size: 15px"></span>
                </v-btn>
                <span style="direction: rtl; text-align: right">{{
                  $t("please_click_apply_changes")
                }}</span>
              </div>

              <v-col
                cols="12"
                style="height: fit-content; position: sticky; top: 0"
              >
                <v-expansion-panels
                  v-model="activePanels"
                  class="px-4"
                  flat
                  accordion
                >
                  <v-expansion-panel
                    v-for="(item, i) in panels"
                    :key="i"
                    class="mb-4"
                  >
                    <v-expansion-panel-header class="text-right">
                      <div class="d-flex justify-space-between align-center">
                        <div>
                          <v-icon class="me-2">mdi-{{ item.icon }}</v-icon>
                          {{ item.title }}
                        </div>
                        <help-info
                          :label="item.title"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="ms-2"
                          :element-name="`${serviceName}-${componentName}-${item.name}-${item.title}`"
                        />
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="py-5">
                      <component
                        :is="item.name"
                        v-model="options"
                        :colors="colors"
                        :readonly="false"
                          :design-object="
                            item.name === 'QrCodeDotsAdv' ? designObject_patttern :
                            item.name === 'QrCodeEyeAdv' ? designObject_dots :
                            item.name === 'QrCodeSquareAdv' ? designObject_square :
                            item.name === 'QrCodeFrameAdv' ? designObject_frames :
                            item.name === 'QrCodeLogoAdv' ? designObject_logos : []
                          "
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <div class="py-5 mt-0 col-md-12">
                <div class="rowinfo mt-0 mr-auto float-left justify-center">
                  <v-btn
                    :disabled="loading"
                    :loading="loading"
                    class="submit-btn"
                    @click="qrUpdate(true)"
                  >
                    <span
                      class="fa fa-save ml-1"
                      style="font-size: 15px"
                    ></span>
                    {{ $t("update_qr") }}
                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-Qr-data-update`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    style="
                      align-self: center !important;
                      padding: unset !important;
                    "
                    :label="$t('update_qr')"
                  />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrCodeMake from "./qrCodeStyle/qrCodeMake";
import axios from "axios";
import { base64ToBlob, saveOnCdnFiles } from "@/utilities/ImageGallery";
import SwiperWrapper from "@/view/pages/businessPage/components/cm/swiperWrapper.vue";
import QRCodeStyling from "qr-code-styling";
import { debounce } from "@/main";
import QrCodeDataAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDataAdv";
import QrCodeDotsAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDotsAdv";
import QrCodeEyeAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeEyeAdv";
import QrCodeOptions from "@/view/pages/qrland/qrCodeStyle/components/qrCodeOptions";
import QrCodeSquareAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeSquareAdv";
import QrCodeFrameAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeFrameAdv";
import QrCodeLogoAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeLogoAdv";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import DownloadFileWithApi from "./downloadFileWithApi.vue";

let qrCode = null;

export default {
  name: "perfessionalDesign",

  components: {
    QrCodeMake,
    QrMaker,
    QrCustomize,
    SwiperWrapper,
    QrCodeDataAdv,
    QrCodeDotsAdv,
    QrCodeEyeAdv,
    QrCodeOptions,
    QrCodeSquareAdv,
    QrCodeFrameAdv,
    QrCodeLogoAdv,
    DownloadFileWithApi,
  },

  data() {
    return {
      hasChanges: false,
      cardTexts: null,
      originData: null,
      cons: { title: this.$t("download_qr") },
      showDialog: false,
      activePanels: [0],
      serviceName: "Qrland",
      componentName: "perfessionaldesign",
      helpData: [],
      qrSvgDataUrl: "",
      designObject_dots: [],
      designObject_patttern: [],
      designObject_square: [],
      designObject_frames: [], 
      designObject_logos: [],

      count: 1,
      toggle_exclusive: 4,
      selectFromGroup: false,
      options: {
        outer_frame: "bottom",
        framelabel: "مرا اسکن کنید",
        label_font: "Parastoo.ttf",
        "label-text-size": 100,
        framecolor: "#1754ec",
        custom_frame_color: "on",

        optionlogo: "02-email-b.png",
        no_logo_bg: "on",
        logo_size: 100,
      
        different_borders_color: false,
        different_eyes_color: false,
        marker_out_color: "#000000",
        marker_in_color: "#000000",
        marker_top_right_center: "#000000",
        marker_top_right_outline: "#000000",
        marker_bottom_left_outline: "#000000",
        marker_bottom_left_center: "#000000",
        different_markers_color: false,
        width: 300,
        height: 300,
        data: "https://qr2.in",
        margin: 5,
        qrOptions: {
          typeNumber: 0,
          mode: "Byte",
          errorCorrectionLevel: "Q",
        },
        imageOptions: {
          hideBackgroundDots: true,
          imageSize: 0.4,
          margin: 0,
        },
        dotsOptions: {
          type: "extra-rounded",
          color: "#6a1a4c",
          gradient: null,
        },
        backgroundOptions: {
          color: "#FFFFFFFF",
          gradient: null,
        },
        image: null,
        dotsOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#6a1a4c",
            color2: "#6a1a4c",
            rotation: "0",
          },
        },
        cornersSquareOptions: {
          type: "extra-rounded",
          gradient: null,
          color: "#690a70",
        },
        cornersSquareOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#000000",
            color2: "#000000",
            rotation: "0",
          },
        },
        cornersDotOptions: {
          type: "",
          color: "#b00cab",
          gradient: null,
        },
        cornersDotOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#000000",
            color2: "#000000",
            rotation: "0",
          },
        },
        backgroundOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#ffffff",
            color2: "#ffffff",
            rotation: "0",
          },
        },
      },
      panels: [
        {
          name: "QrCodeDataAdv",
          title: this.$t("qr_color_size"),
          icon: "qrcode-edit",
        },
        {
          name: "QrCodeDotsAdv",
          title: this.$t("dots_design_color"),
          icon: "dots-triangle",
        },
        {
          name: "QrCodeEyeAdv",
          title: this.$t("eye_design_color"),
          icon: "bullseye",
        },
        {
          name: "QrCodeSquareAdv",
          title: this.$t("border_design_color"),
          icon: "rounded-corner",
        },
        { name: "QrCodeFrameAdv", title: "طراحی قاب", icon: "border-all" }, 
        { name: "QrCodeLogoAdv", title: "تنظیمات لوگو", icon: "image" }, 

        { name: "QrCodeOptions", title: this.$t("qr_settings"), icon: "cogs" },
      ],
      colors: [
        ["#649173", "#DBD5A4"],
        ["#B993D6", "#8CA6DB"],
        ["#870000", "#190A05"],
        ["#00d2ff", "#3a7bd5"],
        ["#DAD299", "#B0DAB9"],
        ["#E6DADA", "#274046"],
        ["#50C9C3", "#96DEDA"],
        ["#4b6cb7", "#182848"],
        ["#EC6F66", "#F3A183"],
        ["#5f2c82", "#49a09d"],
      ],
      stylesList: [
        ["", "dots", "square"],
        [
          "",
          "dot",
          "rounded",
          "classy",
          "classy-rounded",
          "square",
          "extra-rounded",
        ],
        ["", "dot", "square", "extra-rounded"],
      ],
      qrDesign: null,
      data: {},
      svg: "",
      loading: false,
      prompt: "",
      iterativeMode: false,
      showUpgrade: false,
      currentPackage: {},
      result: [],
      indexAt: -1,
      upLoading: false,
      catName: this.$t("created_qr_codes"),
      lastPrompt: "",
      sizeModel: "1:1",
      sizeItems: [
        {
          value: "1:1",
          text: this.$t("square_ratio"),
          width: 1024,
          height: 1024,
          icon: "square-outline",
        },
      ],
      isWriting: false,
    };
  },
  async mounted() {
    this.qrDesign =
      typeof this.options === "string"
        ? JSON.parse(this.options)
        : this.options;
    this.activePanels = [0];
    await this.fetchData();
    this.fetchDesigns();
    qrCode = new QRCodeStyling(this.computedValue);
  },

  computed: {
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrIdf() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },

  watch: {
    options: {
      handler(newVal) {
        this.hasChanges = true;
        // this.updateGradientLogic();
      },
      deep: true,
    },
  },

  methods: {
    setBlackAndWhite() {
  // ۱. پس‌زمینه (سفید)
  if (this.options.backgroundOptions) {
    this.$set(this.options.backgroundOptions, 'color', '#FFFFFFFF');
    this.$set(this.options.backgroundOptions, 'gradient', null);
  }

  // ۲. نقاط بدنه (مشکی)
  if (this.options.dotsOptions) {
    this.$set(this.options.dotsOptions, 'color', '#000000');
    this.$set(this.options.dotsOptions, 'gradient', null);
  }

  // ۳. حاشیه‌های چشم (مشکی)
  if (this.options.cornersSquareOptions) {
    this.$set(this.options.cornersSquareOptions, 'color', '#000000');
    this.$set(this.options.cornersSquareOptions, 'gradient', null);
  }

  // ۴. مرکز چشم‌ها (مشکی)
  if (this.options.cornersDotOptions) {
    this.$set(this.options.cornersDotOptions, 'color', '#000000');
    this.$set(this.options.cornersDotOptions, 'gradient', null);
  }

  // ۵. ریست کردن رنگ‌های اختصاصی چشم‌ها و حاشیه‌ها (حالت پیشرفته)
  this.$set(this.options, 'different_borders_color', false);
  this.$set(this.options, 'different_eyes_color', false);
  this.$set(this.options, 'different_markers_color', false);

  this.$set(this.options, 'marker_out_color', '#000000');
  this.$set(this.options, 'marker_in_color', '#000000');
  this.$set(this.options, 'marker_top_right_center', '#000000');
  this.$set(this.options, 'marker_top_right_outline', '#000000');
  this.$set(this.options, 'marker_bottom_left_outline', '#000000');
  this.$set(this.options, 'marker_bottom_left_center', '#000000');

  // ۶. هلپرهای گرادیانت در UI
  const helpers = [
    'dotsOptionsHelper',
    'cornersSquareOptionsHelper',
    'cornersDotOptionsHelper',
    'backgroundOptionsHelper'
  ];
  helpers.forEach((helper) => {
    if (this.options[helper] && this.options[helper].colorType) {
      this.$set(this.options[helper].colorType, 'single', true);
      this.$set(this.options[helper].colorType, 'gradient', false);
    }
  });

  // ۷. اعمال تغییرات و درخواست به سرور
  this.hasChanges = true;
  this.createAdvance();
},
    updateGradientLogic() {
      // Create a new object to avoid mutating the watched object directly
      const newOptions = { ...this.options };

      if (newOptions.dotsOptionsHelper.colorType.single) {
        newOptions.dotsOptions.gradient = null; // Disable gradient
        // newOptions.dotsOptionsHelper.colorType.gradient = false;
      } else {
        // newOptions.dotsOptionsHelper.colorType.gradient = true;
        newOptions.dotsOptions.gradient = {
          type: "linear",
          rotation: 0,
          colorStops: [
            {
              offset: 0,
              color: newOptions.dotsOptionsHelper.gradient.color1,
            },
            {
              offset: 1,
              color: newOptions.dotsOptionsHelper.gradient.color2,
            },
          ],
        };
      }
      this.options = newOptions;
    },
    convertPathToSvg(path) {
      let svgContent = "";
      if (typeof path === "object" && path !== null) {
        svgContent = path.preview || path.path || "";
      } else {
        svgContent = path || "";
      }
      if (!svgContent) {
        console.warn("Invalid or missing SVG content:", path);
        svgContent = '<path d="" fill="#000" stroke="#000" stroke-width="1" />';
      }
      if (!svgContent.includes("fill=")) {
        svgContent = svgContent.replace(
          /\/?>/,
          ' fill="#000" stroke="#000" stroke-width="1"$&',
        );
      }
      const svgWrapper = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 6" >
      ${svgContent}
  </svg>`;
      return !btoa(svgWrapper).includes(`data:image/svg+xml;base64,`)
        ? `data:image/svg+xml;base64,${btoa(svgWrapper)}`
        : btoa(svgWrapper);
    },
    fetchDesigns() {
  this.$api.get("/v2/qr-gen/markers")
    .then(({ data }) => {
      const apiData = data.data;
      
      this.designObject_patttern = Object.keys(apiData.pattern || {}).map((key) => ({ value: key, img: apiData.pattern[key] }));
      this.designObject_dots = Object.keys(apiData.markerIn || {}).map((key) => ({ value: key, img: apiData.markerIn[key] }));
      this.designObject_square = Object.keys(apiData.markerOut || {}).map((key) => ({ value: key, img: apiData.markerOut[key] }));
      
      this.designObject_frames = Object.keys(apiData.frames || {}).map((key) => ({ 
        value: key, 
        data: apiData.frames[key] 
      }));
      
      this.designObject_logos = Object.keys(apiData.logos || {}).map((key) => ({ 
        value: key, 
        img: apiData.logos[key].preview 
      }));
    })
    .catch(() => {});
},
    async convertSvgUrlToData(svgUrl) {
      try {
        const response = await fetch(svgUrl);
        const svgText = await response.text();
        const base64Svg = btoa(svgText);
        return base64Svg;
      } catch (error) {
        return null;
      }
    },
    async fetchData() {
      this.loading = true;
      this.$api
        .get(
          this.$route.fullPath.includes("qr/design2")
            ? `/v1/testQr/find1/${this.domainName}`
            : `/v1/testQr/find/${this.domainName}${
                this.qrIdf ? "/" + this.qrIdf : ""
              }`,
        )
        .then(async ({ data }) => {
          this.data = data.data || {};
          this.cardTexts = data.data.data?.data || {};
          this.originData = data.data.data || {};
          this.qrId = this.data.qrId;
          if (
            this.cardTexts.tab_design === undefined ||
            this.cardTexts.tab_design === null ||
            this.cardTexts.tab_design === 1
          ) {
            this.qrSvgDataUrl = this.data.img_url || data.data.image || "";
            this.qrDesign =
              typeof data.data.qr === "string"
                ? JSON.parse(data.data.qr)
                : data.data.qr;
            this.$nextTick(() => {
              if (this.$refs.qrCanvas) {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }
            });
            this.svg = data.data.svg || "";
          } else if (this.cardTexts.tab_design === 0) this.createAdvance();
        })
        .finally(() => (this.loading = false));
    },
     async qrUpdate(final = false) {
  this.loading = true;
  const data = new FormData();

  let finalImage = this.qrSvgDataUrl;

  if (finalImage && finalImage.startsWith('http')) {
    const base64Str = await this.convertSvgUrlToData(finalImage);
    if (base64Str) {
      finalImage = `data:image/svg+xml;base64,${base64Str}`;
    }
  } else if (finalImage && !finalImage.includes(`data:image/svg+xml;base64,`)) {
    finalImage = `data:image/svg+xml;base64,${finalImage}`;
  }

  if (this.$route.fullPath.includes("qr/design2")) {
    data.append("title", this.data.title);
    data.append("type", this.data.type);
    data.append("identifier", this.data.identifier);
    data.append("_method", "PUT");
    data.append("qr_id", this.data.qrId);
    data.append("image", finalImage);
    data.append("qr", JSON.stringify(this.qrDesign));
  } else {
    data.append("domain", this?.data?.domain?.name);
    data.append("identifier", this.data.identifier);
    data.append("type", this.data.type);
    data.append("_method", "PUT");
    data.append("image", finalImage);
    data.append("qr", JSON.stringify(this.qrDesign));
    data.append("qr_id", this.data.qrId);
  }
  
      const updatedCardTexts = {
        ...this.cardTexts,
        tab_design: 1,
      };
      const updatedData = {
        ...this.originData,
        data: updatedCardTexts,
      };
      data.append("data", JSON.stringify(updatedData));

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          this.finish = final;
          if (final) {
            this.goto("qr/list");
          } else {
            this.fetchData();
          }
          this.$toast.success(this.$t("qr_visit_card_edited_successfully"));
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
          this.hasChanges = false;
        });
    },
    autoSave(options) {
      this.qrDesign = options;
      this.hasChanges = true;
    },
    saveImage() {
      this.upLoading = true;
      const base64String = this.result.at(this.indexAt).image;
      const mimeType = "application/octet-stream";
      const fileBlob = base64ToBlob(base64String, mimeType);
      saveOnCdnFiles(
        fileBlob,
        this.result.at(this.indexAt).prompt.replace(/ /g, "_"),
        this.catName,
      )
        .then((response) => {
          this.$emit("saved", this.catName);
        })
        .catch((error) => {
          this.$toast.error(this.$t("image_upload_error"));
        })
        .finally(() => (this.upLoading = false));
    },
    createAdvance() {
      this.loading = true;
      this.qrSvgDataUrl = "";
      this.hasChanges = true;

      const opt = this.options;
      let backgroundColor = this.isGradient(opt.backgroundOptions);
      let frontColor = this.isGradient(opt.dotsOptions);
      let cornerSquare = this.isGradient(opt.cornersSquareOptions);
      let cornerDots = this.isGradient(opt.cornersDotOptions);

      const apiData = {
        outer_frame: opt.outer_frame,
        framelabel: opt.framelabel,
        label_font: opt.label_font,
        "label-text-size": opt["label-text-size"],
        framecolor: opt.custom_frame_color === 'on' ? opt.framecolor : '',
        custom_frame_color: opt.custom_frame_color,
        
        optionlogo: opt.optionlogo,
        no_logo_bg: opt.no_logo_bg,
        logo_size: opt.logo_size,

        selectFromGroup: this.selectFromGroup,
        param: this.data.link,
        type: "url",
        number: 1,

        // ==========================================
        // تنظیمات رنگ حاشیه‌ها (Borders / Marker Out)
        // ==========================================
        marker_out_color: opt.different_borders_color
          ? opt.marker_out_color
          : cornerSquare.color,
        marker_top_right_outline: opt.different_borders_color
          ? opt.marker_top_right_outline
          : cornerSquare.color,
        marker_bottom_left_outline: opt.different_borders_color
          ? opt.marker_bottom_left_outline
          : cornerSquare.color,

        // ==========================================
        // تنظیمات رنگ چشم‌ها (Eyes / Marker In)
        // ==========================================
        marker_in_color: opt.different_eyes_color
          ? opt.marker_in_color
          : cornerDots.color,
        marker_top_right_center: opt.different_eyes_color
          ? opt.marker_top_right_center
          : cornerDots.color,
        marker_bottom_left_center: opt.different_eyes_color
          ? opt.marker_bottom_left_center
          : cornerDots.color,

        // ==========================================
        // متغیر کنترل‌کننده برای بک‌اند
        // ==========================================
        // اگر یا چشم‌ها و یا حاشیه‌ها حالت چندرنگ داشتند، این مقدار باید true باشد
        different_markers_color:
          opt.different_borders_color || opt.different_eyes_color,

        backcolor: backgroundColor.color,
        frontcolor: frontColor.color,
        radial: false,
        gradient: frontColor.isGradient,
        gradient_color: frontColor.color1,
        markers_color: true,
        level: opt.qrOptions.errorCorrectionLevel || "H",
        pattern: opt.dotsOptions.type || "default",
        marker_out: opt.cornersSquareOptions.type || "default",
        marker_in: opt.cornersDotOptions.type || "default",
      };

      this.$api
        .post("/v2/qr-gen/group", apiData)
        .then(({ data }) => {
          let r = [];
          data.data.forEach((item) => r.push(item.content));
          this.qrSvgDataUrl = !r[0].includes(`data:image/svg+xml;base64,`)
            ? `data:image/svg+xml;base64,${r[0]}`
            : r[0];
          this.data.img_url = this.qrSvgDataUrl;
          this.data.image = this.qrSvgDataUrl;
          this.data = { ...this.data };

          this.$forceUpdate();
        })
        .finally(() => {
          this.loading = false;
          this.hasChanges = false;
        });
    },
    updateStyle() {
      debounce(() => {
        this.createAdvance();
      }, 100);
    },
    ranColor() {
      return new Promise((resolve, reject) => {
        let rand = this.colors[Math.floor(Math.random() * 10)];
        try {
          this.options.dotsOptions.gradient = {
            type: "linear",
            rotation: 0,
            colorStops: [
              { offset: 0, color: rand[0] },
              { offset: 1, color: rand[1] },
            ],
          };
          resolve("resolve");
        } catch (e) {
          reject();
        }
      });
    },
    downloadSvgImg(base64, index) {
      const filename = `image-${this.options.data
        .trim()
        .replace(/\.*\s*/g, "_")}-${index}.png`;

      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let pngData = "";
      canvas.width = 300;
      canvas.height = 300;
      let image = new Image();
      image.onload = function () {
        context.clearRect(0, 0, 300, 300);
        context.drawImage(image, 0, 0, 300, 300);
        pngData = canvas.toDataURL("image/png");
        const byteCharacters = atob(pngData.split(",")[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      };
      image.src = base64;
    },
    downloadImg(base64, index) {
      const filename = `image-${this.options.data
        .trim()
        .replace(/\.*\s*/g, "_")}-${index}.png`;
      const byteCharacters = atob(base64.split(",")[1]);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/png" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    isGradient(opt) {
      let res = {
        color: "",
        color1: "",
        isGradient: false,
      };
      if (opt.hasOwnProperty("gradient") && !!opt.gradient) {
        res = {
          isGradient: true,
          color: opt.gradient.colorStops[0].color,
          color1: opt.gradient.colorStops[1].color,
        };
      } else {
        res = {
          isGradient: false,
          color: opt.color,
          color1: null,
        };
      }
      return res;
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}

.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

.advance-image-data,
.advance-image-data >>> svg {
  max-width: 100%;
  max-height: 120px;
}
.downloadbtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  gap: 2px;
}
.coverdownload {
  display: flex;
  flex-direction: column !important;
  justify-content: center !important;
  justify-items: center !important;
  align-items: center !important;
  gap: 2px;
  align-self: flex-start;
  text-align: center !important;
}
</style>
